module.exports = __webpack_public_path__ + "img/picture_45.0ac9189a.png";